import {
    GET_USERS,
    SET_CURRENT_USER,
    FORGOT_PASSWORD,
    USER_QLIK_TICKET,
    AUTH_MUTLTIFACTOR_MESSAGE,
    AUTH_ALERT,
    AUTH_LOGIN,
    GET_API_KEY,
    AUTH_ERRORS,
    AUTH_PASSWORD_RESET_TOKEN,
    AUTH_EMAIL_VERIFIED,
    SHOW_PAYMENT,
    SHOW_SUBSCRIPTION,
    SHOW_SUBSCRIPTION_WITH_USER,
    SHOW_REGISTRATION,
    SET_SELECTED_PRODUCT,
    SHOW_PAYMENT_SUCCESS,
    AUTH_GET_PRICING_CARDS,
    GET_CURRENT_USER,
    LOGIN_FLAG,
    REDIRECT_URL,
} from '../actions/types';
import * as lodash from 'lodash';
const { isEmpty } = lodash;

const initialState = {
    isAuthenticated: false,
    user: {},
    login: {},
    qlikTicket: null,
    alert: null,
    apiKey: null,
    users: null,
    authMultiFactorMessage: null,
    passwordReset: {},
    loading: false,
    errors: null,
    validPasswordResetToken: false,
    showSubscription: false,
    showPayment: false, // DEBUG: false
    showRegistration: true, // DEBUG: true
    showPaymentSuccess: false,
    profile: null,
    selectedProduct: {},
    pricing: null,
    loginFlag: false,
    redirectUrl: null,
    /*selectedProduct: {
   title: 'Pay as you go',
   description: 'Ideal for smaller clubs and introductions to the platform with 2 free weeks',
   price: 'TBC',
   buttonText: 'Begin your free trial',
   free: true,
   type: 'payg',
   stripePriceId: 'price_1GuEZeFrQg2mm1KYtOjd13tr',
   },*/
};

export default function (state = initialState, action) {
    switch (action.type) {
        case SET_CURRENT_USER:
            return {
                ...state,
                isAuthenticated: !isEmpty(action.payload),
                user: action.payload,
                authMultiFactorMessage: null,
                loading: false,
                errors: null,
                showSubscription: false,
                showPayment: false,
                showPaymentSuccess: false,
            };
        case GET_CURRENT_USER:
            return {
                ...state,
                profile: action.payload,
                loading: false,
                errors: null,
            };
        case LOGIN_FLAG:
            return {
                ...state,
                loginFlag: action.payload
            };
        case REDIRECT_URL:
            return {
                ...state,
                redirectUrl: action.payload
            };
        case USER_QLIK_TICKET: {
            return {
                ...state,
                qlikTicket: action.payload,
                authMultiFactorMessage: null,
                loading: false,
                errors: null,
                showSubscription: false,
                showPayment: false,
                showPaymentSuccess: false,
            };
        }
        case GET_USERS:
            return {
                ...state,
                users: action.payload,
                loading: false,
                errors: null,
            };
        case AUTH_LOGIN:
            return {
                ...state,
                login: action.payload,
                loading: false,
                errors: null,
            };
        case FORGOT_PASSWORD:
            return {
                ...state,
                loading: false,
                passwordReset: action.payload,
                authMultiFactorMessage: null,
                errors: null,
            };
        case AUTH_ALERT:
            return {
                ...state,
                loading: false,
                alert: action.payload,
                errors: null,
            };
        case GET_API_KEY:
            return {
                ...state,
                loading: false,
                apiKey: action.payload,
                errors: null,
            };
        case AUTH_ERRORS:
            return {
                ...state,
                errors: action.payload,
                loading: false,
            };
        case AUTH_MUTLTIFACTOR_MESSAGE:
            return {
                ...state,
                isAuthenticated: false,
                user: null,
                authMultiFactorMessage: action.payload,
                loading: false,
                errors: null,
            };
        case AUTH_PASSWORD_RESET_TOKEN:
            return {
                ...state,
                validPasswordResetToken: action.payload,
                authMultiFactorMessage: null,
                loading: false,
                errors: null,
            };
        case AUTH_EMAIL_VERIFIED:
            return {
                ...state,
                emailVerified: action.payload,
                loading: false,
                errors: null,
                showSubscription: false,
                showPayment: false,
                showPaymentSuccess: false,
            };
        case SHOW_REGISTRATION:
            return {
                ...state,
                showRegistration: true,
                showSubscription: false,
                showPayment: false,
                showPaymentSuccess: false,
            };
        case SHOW_SUBSCRIPTION_WITH_USER:
            return {
                ...state,
                user: action.payload,
                showSubscription: true,
                showPayment: false,
                showRegistration: false,
                showPaymentSuccess: false,
            };
        case SHOW_SUBSCRIPTION:
            return {
                ...state,
                showSubscription: true,
                showPayment: false,
                showRegistration: false,
                showPaymentSuccess: false,
            };
        case SHOW_PAYMENT:
            return {
                ...state,
                user: action.payload,
                showSubscription: false,
                showPayment: true,
                showRegistration: false,
                showPaymentSuccess: false,
            };
        case SET_SELECTED_PRODUCT:
            return {
                ...state,
                selectedProduct: action.payload,
            };
        case SHOW_PAYMENT_SUCCESS:
            return {
                ...state,
                showPaymentSuccess: true,
                showPayment: false,
            };
        case AUTH_GET_PRICING_CARDS:
            return {
                ...state,
                loading: false,
                pricing: action.payload,
            };
        default:
            return state;
    }
}
